module.exports = __webpack_public_path__ + "img/12.87b4684a.jpg";